(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.elements = {
          input: this.querySelector('input[name="country_code"], input[name="locale_code"]'),
          button: this.querySelector('.disclosure__button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('.localization-search'),
          list: this.querySelector('.disclosure__list')
        };
        if (this.elements.button) {
          this.elements.button.addEventListener('click', this.openSelector.bind(this));
        }
        if (this.elements.search) {
          this.elements.search.addEventListener('input', this.filterCountries.bind(this));
          this.elements.search.addEventListener('keydown', this.preventSearchSubmit.bind(this));
          this.elements.search.addEventListener('click', this.keepPanelOpen.bind(this));
          this.elements.search.addEventListener('focus', this.keepPanelOpen.bind(this));
        }
        if (this.elements.list) {
          this.elements.list.addEventListener('click', this.handleCountryClick.bind(this));
        }
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      }

      hidePanel() {
        if (!this.elements.button || !this.elements.panel) return;
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', '');
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        if (this.elements.button) this.elements.button.focus();
      }

      openSelector() {
        if (!this.elements.button || !this.elements.panel) return;
        const isOpening = this.elements.panel.hasAttribute('hidden');
        if (isOpening) {
          this.elements.panel.removeAttribute('hidden');
          this.elements.button.setAttribute('aria-expanded', 'true');
          if (this.elements.search) {
            window.setTimeout(() => this.elements.search.focus(), 0);
          }
        } else {
          this.hidePanel();
        }
      }

      keepPanelOpen(event) {
        event.stopPropagation();
        if (this.elements.panel) this.elements.panel.removeAttribute('hidden');
        if (this.elements.button) this.elements.button.setAttribute('aria-expanded', 'true');
      }

      handleCountryClick(event) {
        const countryLink = event.target.closest('.disclosure__link[data-value]');
        if (!countryLink || !this.contains(countryLink)) return;
        event.preventDefault();
        event.stopPropagation();
        const countryCode = countryLink.getAttribute('data-value');
        if (!countryCode || !this.elements.input) return;
        this.elements.input.value = countryCode;
        const form = countryLink.closest('form');
        if (form) {
          HTMLFormElement.prototype.submit.call(form);
        }
      }

      preventSearchSubmit(event) {
        if (event.key === 'Enter') event.preventDefault();
      }

      filterCountries(event) {
        const searchTerm = event.target.value.trim().toLowerCase();
        const panel = event.target.closest('.disclosure__list-wrapper');
        if (!panel) return;
        const items = panel.querySelectorAll('.disclosure__item');
        items.forEach(item => {
          const searchableText = item.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
          const shouldHide = searchTerm !== '' && !searchableText.includes(searchTerm);
          item.hidden = shouldHide;
          item.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
        });
        const list = panel.querySelector('.disclosure__list');
        if (list) {
          list.scrollTop = 0;
        }
      }
    }

    customElements.define('localization-form', LocalizationForm);


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            console.log(text);
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
              let sameCard = document.querySelector('.from-recommended');
              let cardHeight = parseInt(sameCard.clientHeight);
              let topValue = cardHeight / 2 + 5;
              let cardTopCSS = "calc(50% - "+topValue+'px)';
              let swiperContainer = document.querySelector('.product-recommendations .swiper');
              let swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');
              let swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
              swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);
              swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
